<script setup>
import { onMounted } from 'vue';
import { useRoadmapsStore } from '@/stores/roadmaps';
import SiteHeader from '@/components/site/SiteHeader.vue';
import SiteFooter from '@/components/site/SiteFooter.vue';
import ProjectModal from '@/components/modals/ProjectModal.vue';
import DialogHost from '@/components/ui/DialogHost.vue';

const store = useRoadmapsStore();
onMounted(() => store.load());
</script>

<template>
  <SiteHeader />
  <main>
    <RouterView />
  </main>
  <SiteFooter />
  <ProjectModal />
  <DialogHost />
</template>
